// Module
var code = "<div class=\"assessment-item\" ng-transclude> </div>";
// Exports
module.exports = code;